import React from "react";
import { CREDIT_COLORS } from "../../../../constants";
import "./CoinUsage.css";
export default function CoinUsage({ creditUsage, type }) {
  return (
    <span
      id={"coin-usage"}
      style={{
        color: CREDIT_COLORS[type].color,
        background: CREDIT_COLORS[type].color + "12",
      }}
    >
      <img src={CREDIT_COLORS[type].icon} alt="" />
      <span
        style={{
          color: CREDIT_COLORS[type].color,
        }}
      >
        {creditUsage}
      </span>
    </span>
  );
}
